var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('full-page',{on:{"after-load":_vm.afterLoad}},[_c('page-netease')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }